import React from 'react';

import { Paper, Typography, Stack, Link } from '@mui/material';

export const ReferenceLinks = ({ ref_links }) => {
  return (
    <Paper
      sx={{
        borderRadius: 10,
        boxShadow: '0 2px 4px -2px rgba(0,0,0,0.24), 0 4px 24px -2px rgba(0, 0, 0, 0.2)',
        p: { md: 2, sm: 2, xs: 2 },
        mt: 1
      }}
      elevation={9}>
      <Typography variant="h6" gutterBottom component="div">
        {`Reference links`}
      </Typography>

      <Stack>
        {ref_links.map((data, index) => {
          return data?.link_url?.includes('http') ? (
            <Link href={data.link_url} underline="hover" target="_blank" rel="noopener" key={index}>
              {data.link_name}
            </Link>
          ) : (
            <Typography variant="subtitle1" gutterBottom>
              {data.link_name}
            </Typography>
          );
        })}
      </Stack>
    </Paper>
  );
};
